import React from "react";
import "antd/dist/antd.css";
import "./App.css";
import { TodoList } from "./components/TodoList";

function App() {
  return (
    <div className="App">
      <TodoList />
    </div>
  );
}

export default App;
